import React from "react";

function InputErrorMessage({ children }) {
  return <div className="text-danger mt-2">{children}</div>;
}

export default InputErrorMessage;
